import BaseResource from './index'
import ReservationResource from './reservation'
import UserResource from './user'

export default class ReservationSeatedUserResource extends BaseResource {
    static endpoint = '/reservations/seating/assignments'

    static related() {
        return {
            reservation: ReservationResource,
            user: UserResource,
        }
    }

    static async assign(reservationId, userId) {
        const response = await this.client.post(`${this.endpoint}/`, { reservation: reservationId, user: userId })
        return new ReservationSeatedUserResource(response.data)
    }

    static async clear(seatedUserId) {
        return await this.client.delete(`${this.endpoint}/${seatedUserId}/`)
    }
}
